import { isCsShotUzHost } from '@/runtime/host';

export interface LegalLinks {
  userAgreement: string;
  privacyPolicy: string;
  refundPolicy?: string;
  paymentOrder?: string;
}

const DEFAULT_LINKS: LegalLinks = {
  userAgreement: 'https://telegra.ph/Polzovatelskoe-soglashenie-SHO-12-07',
  privacyPolicy: 'https://telegra.ph/Politika-konfidencialnosti-01-12-34',
};

const CS_SHOT_UZ_LINKS: LegalLinks = {
  userAgreement: 'https://telegra.ph/Polzovatelskoe-sglashenie-06-28',
  privacyPolicy: 'https://telegra.ph/POLITIKA-KONFIDENCIALNOSTI-06-28-18',
  refundPolicy: 'https://telegra.ph/REFUND-POLICY-SHOT-06-28',
  paymentOrder: 'https://telegra.ph/Poryadok-oplaty-07-02',
};

export function getLegalLinks(host: string): LegalLinks {
  return isCsShotUzHost(host) ? CS_SHOT_UZ_LINKS : DEFAULT_LINKS;
}
